import React from 'react';
import { useProductSubmissions } from './useProductSubmissions';
import { ButtonOptionPicker, Buttons, LoadingIndicator, MoreActionsMenuButton, OccupyFreeSpace, SearchField, useCopyText } from '../../../toolympus/components/primitives';
import { TableForFields } from '../../../toolympus/components/schemed';
import { Button, Typography } from '@mui/material';
import { GetAppOutlined } from '@mui/icons-material';
import { Product } from './useProductsList';

interface Props {
  product: Product;
  isPaid?: boolean;
}

export const ProductSubmissionsList = (props: Props) => {
  const data = useProductSubmissions("admin", props.product)
  const copyText = useCopyText();

  return (
    <>
      <Buttons>
        <ButtonOptionPicker
          options={[
            ["all", "all"],
            ["unprocessed", "unprocessed"],
            ["processed", "processed"],
          ]}
          selected={data.view.value}
          setSelected={v => data.view.update(v)}
          />
        <Typography style={{ alignSelf: "flex-end" }} variant="caption">Submissions: {data.data.length}</Typography>
        <OccupyFreeSpace />
        {data.isLoading && <LoadingIndicator />}
        <SearchField
          filter={data.filter.filter}
          setFilter={data.filter.setFilter}
          autoFocus
          noButton
          small
          />
        <Button startIcon={<GetAppOutlined />} size="small" color="primary" onClick={() => data.exportRecords()}>
          export
        </Button>
      </Buttons>
      
      <TableForFields
        data={data.data}
        schema={data.schema}
        fields={[
          ["actions", { label: " ", width: 35 } ],
          ["registration_status"],
          ["email"],
          // ["display_name"],
          props.isPaid ? ["is_paid"] : null,
          props.isPaid ? ["invoice_paid_at", { utcToLocal: true }] : null,
          props.isPaid ? ["paid_amount"] : null,
          props.isPaid ? ["invoice_amount"] : null,
          props.isPaid ? ["applied_discount_amount"] : null,
          props.isPaid ? ["applied_discount_code"] : null,
          props.isPaid ? ["invoice_nbr"] : null,
          ...data.profileFields,
          ["created_at", { utcToLocal: true }],
          ["status_log"],
        ]}
        fieldElement={f => {
          if(f === "actions") {
            return (row) => (
              <Buttons style={{ width: 60 }}>
                <MoreActionsMenuButton
                  actions={[
                    // ["approve", "Approve", () => data.approve.run(row)],
                    // ["reject", "Reject", () => data.reject.run(row)],
                    ["copyid", `Copy ID: ${row._id}`, () => copyText(`${row._id}`)],
                  ]}
                  />

                {data.comments.buttonForRecord(`${row._id}`)}
              </Buttons>
            )
          }
        }}
        />

      {data.comments.popup}
    </>
  );
}

